import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainNavigationComponent } from '@ace/ace';
import { AuthserviceService } from "@ace/ace";

const routes: Routes = [
  {
    path: 'issue-form/:callId',
    loadComponent: () =>
      import('./layouts/public-issue-form/public-issue-form.component').then(
        (m) => m.PublicIssueFormComponent
      ),
  },
  {
    path: 'issue-form',
    loadComponent: () =>
      import('./layouts/public-issue-form/public-issue-form.component').then(
        (m) => m.PublicIssueFormComponent
      ),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('@ace/ace').then((m) => m.LoginModule),
  },
  {
    path: 'forgot-password',
    loadChildren: () =>
      import('@ace/ace').then(
        (m) => m.ForgotPasswordModule
      ),
  },
  {
    path: 'reset-password',
    loadChildren: () =>
      import('@ace/ace').then(
        (m) => m.ResetPasswordModule
      ),
  },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'main',
    component: MainNavigationComponent,
    children: [
      { path: '', redirectTo: 'landing-page', pathMatch: 'full' },
      {
        path: 'landing-page',
        loadChildren: () =>
          import('./layouts/kpis/kpis.module').then(
            (m) => m.KpisModule
          ),
      },

      {
        path: 'inbound',
        loadChildren: () =>
          import('./layouts/inbound-data-console/inbound-data-console.module').then(
            (m) => m.InboundDataConsoleModule
          ),
      },
      {
        path: 'outbound',
        loadChildren: () =>
          import('./layouts/outbound-data-console/outbound-data-console.module').then(
            (m) => m.OutboundDataConsoleModule
          ),
      },
      {
        path: 'outbound-calls',
        loadChildren: () =>
          import('./layouts/outbound-calls/outbound-calls.module').then(
            (m) => m.OutboundCallsModule
          ),
      },
      {
        path: 'campaign',
        loadChildren: () =>
          import('./layouts/campaign/campaign.module').then(
            (m) => m.CampaignModule
          ),
      },
      {
        path: 'dnc',
        loadChildren: () =>
          import('./layouts/dnc/dnc.module').then(
            (m) => m.DncModule
          ),
      },
      {
        path: 'contacts',
        loadChildren: () =>
          import('./layouts/contacts/contacts.module').then(
            (m) => m.ContactsModule
          ),
      },
      {
         path: 'kpis',
        loadChildren: () =>
          import('./layouts/kpis/kpis.module').then(
            (m) => m.KpisModule
          ),
      },
      {
        path: 'inbound-calls',
        loadChildren: () =>
          import('./layouts/inbound-calls/inbound-calls.module').then(
            (m) => m.InboundCallsModule
          ),
      },
      {
        path: 'master-management',
        loadChildren: () =>
          import('@ace/ace').then(
            (m) => m.MasterManagementV2Module
          ),
      },
      {
        path: 'master-management-v2',
        loadChildren: () =>
          import(
            '@ace/ace'
          ).then((m) => m.MasterManagementV2Module),
      },


      {
        path: 'user-logging',
        loadChildren: () =>
          import("@ace/ace").then(
            (m) => m.UserLoggingModule,
          )
      },
      {
        path: 'inquiries',
        loadChildren: () =>
          import('@ace/ace').then(
            (m) => m.InquiriesModule
          ),
      },
      {
        path: 'alerts',
        loadChildren: () =>
          import('@ace/ace').then((m) => m.AlertsModule),
      },
      /** To be modified later **/
      {
        path: 'landing-list/:moduleId',
        loadComponent: () =>
          import(
            '@ace/ace'
          ).then((m) => m.DynamicLandingListComponent),
      },
      {
        path: ':moduleId/form/:action',
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                '@ace/ace'
              ).then((m) => m.FormHandlingComponent),
          },
          {
            path: '',
            loadComponent: () =>
              import(
                '@ace/ace'
              ).then((m) => m.FormHandlingComponent),
          },
        ],
      },
      {
        path: 'voicebot-settings',
        loadChildren: () =>
          import('./layouts/voicebot-settings/voicebot-settings.module').then(
            (m) => m.VoicebotSettingsModule
          ),
      },
      {
        path: 'ai-configs',
        loadChildren: () =>
          import('./layouts/ai-configs/ai-configs.module').then(
            (m) => m.AiConfigsModule
          ),
      },
      {
        path: 'inbound-settings',
        loadChildren: () =>
          import('./layouts/inbound-settings/inbound-settings.module').then(
            (m) => m.InboundSettingsModule
          ),
      },
      {
        path: 'outbound-settings',
        loadChildren: () =>
          import('./layouts/outbound-settings/outbound-settings.module').then(
            (m) => m.OutboundSettingsModule
          ),
      },

      {
        path: 'case-details',
        loadComponent: () =>
          import('@ace/ace').then(
            (m) => m.CaseDetailsComponent
          ),
      },
      {
        path: 'casedetails',
        loadComponent: () =>
          import('@ace/ace').then(
            (m) => m.CaseDetailsComponent
          ),
      },

      {
        path: 'tasks',
        loadChildren: () =>
          import('@ace/ace').then((m) => m.TasksModule),
      },
      {
        path: 'system-reports-v2',
        loadChildren: () =>
          import('@ace/ace').then(
            (m) => m.SystemReportsV2Module
          ),
      },
      {
        path: 'audit-trail',
        loadChildren: () =>
          import('@ace/ace').then(
            (m) => m.AuditTrailModule
          ),
      },
      {
        path: 'user-management',
        loadChildren: () =>
          import('@ace/ace').then(
            (m) => m.UserManagementModule
          ),
      },
      {
        path: 'configuration',
        loadChildren: () =>
          import('@ace/ace').then(
            (m) => m.ConfigurationModule
          ),
      },
      {
        path: 'querybuilder',
        loadChildren: () =>
          import(
            '@ace/ace' // Adjust the path as necessary
          ).then((m) => m.QuerybuilderModule),
      },
      {
        path: 'data-integration',
        loadChildren: () =>
          import('@ace/ace').then(
            (m) => m.DataIntegrationModule
          ),
      },

      {
        path: 'smtp-configuration',
        loadChildren: () =>
          import('@ace/ace').then(
            (m) => m.SmtpConfigurationModule
          ),
      },
      {
        path: 'security',
        loadChildren: () =>
          import('@ace/ace').then(
            (m) => m.SecurityModule
          ),
      },
      {
        path: 'active-dir-management',
        loadChildren: () =>
          import('@ace/ace').then(
            (m) => m.ActiveDirManagementModule
          ),

      },
      {
        path: 'active-calls',
        loadComponent: () =>
          import('./layouts/active-calls/active-calls.component').then(
            (m) => m.ActiveCallsComponent
          ),
      },
      {
        path: 'agents',
        loadChildren: () =>
          import('./layouts/agents/agents.module').then(
            (m) => m.AgentsModule
          ),
      },
      {
        path: 'llm-agents',
        loadChildren: () =>
          import('./layouts/llm-agents/llm-agents.module').then(
            (m) => m.LlmAgentsModule
          ),
      },
      {
        path: 'business-hours',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./layouts/business-hours/business-hours.component').then(
                (m) => m.BusinessHoursComponent
              ),
          },
          {
            path: 'special-days',
            loadComponent: () =>
              import('./layouts/business-hours/business-hours-special-days.component').then(
                (m) => m.BusinessHoursSpecialDaysComponent
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./layouts/business-hours/business-hours.component').then(
                (m) => m.BusinessHoursComponent
              ),
          },
        ],
      },
    ],
    canActivate: [AuthserviceService],
  },
  // { path: '**', redirectTo: 'login', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
